<!-- eslint-disable -->
<template>
    <div class="minimal-auth-wrapper">
        <div class="auth-container">
            <!-- Logo Section -->
            <div class="logo-section">
                <b-img
                    :src="business.logo"
                    :alt="business.name"
                    class="brand-logo"
                />
            </div>

            <!-- Login Card -->
            <div class="login-card">
                <!-- Header -->
                <div class="login-header">
                    <h1 class="login-title">Ingresa tu correo electrónico</h1>
                    <p class="login-subtitle">
                        Te enviaremos un enlace seguro para continuar
                    </p>
                </div>

                <!-- Form -->
                <validation-observer ref="loginForm" #default="{ invalid }">
                    <b-form class="login-form" @submit.prevent="sendMagicLink">
                        <!-- Email Input -->
                        <b-form-group class="form-group">
                            <label for="email" class="form-label">Email</label>
                            <validation-provider
                                #default="{ errors }"
                                name="Email"
                                rules="required|email"
                            >
                                <b-form-input
                                    id="email"
                                    v-model="userEmail"
                                    name="login-email"
                                    :state="errors.length > 0 ? false : null"
                                    placeholder="tu@ejemplo.com"
                                    class="form-input"
                                    autofocus
                                />
                                <small class="error-text" v-if="errors[0]">{{
                                    errors[0]
                                }}</small>
                            </validation-provider>
                        </b-form-group>

                        <!-- Submit Button -->
                        <b-button
                            v-if="!isLoading"
                            variant="primary"
                            type="submit"
                            block
                            :disabled="invalid"
                            class="submit-btn"
                        >
                            Continuar
                        </b-button>

                        <b-button
                            v-if="isLoading"
                            variant="primary"
                            disabled
                            block
                            class="submit-btn"
                        >
                            <b-spinner small class="mr-2" />
                            Enviando...
                        </b-button>

                        <!-- Info Text -->
                        <div class="info-text">
                            <feather-icon icon="InfoIcon" size="16" />
                            <span
                                >Te enviaremos un enlace seguro a tu
                                correo</span
                            >
                        </div>
                    </b-form>
                </validation-observer>
            </div>

            <!-- Payment Methods -->
            <div class="payment-methods">
                <p class="payment-label">Métodos de pago</p>
                <div class="payment-images">
                    <b-img :src="brands.visa" alt="Visa" class="brand-img" />
                    <b-img
                        :src="brands.mastercard"
                        alt="Mastercard"
                        class="brand-img"
                    />
                    <b-img
                        :src="brands.visaSecure"
                        alt="Visa Secure"
                        class="brand-img"
                    />
                    <b-img
                        :src="brands.mcIdCheck"
                        alt="Mastercard ID Check"
                        class="brand-img"
                    />
                    <b-img
                        :src="imgPayPal"
                        alt="PayPal"
                        class="payment-img-paypal"
                    />
                </div>
            </div>

            <div class="footer-divider" />

            <!-- Enlaces legales -->
            <div class="legal-links">
                <b-link :to="{ name: 'legal-services' }">Servicios</b-link>
                <b-link :to="{ name: 'legal-terms' }">Términos</b-link>
                <b-link :to="{ name: 'legal-privacy' }">Privacidad</b-link>
                <b-link :to="{ name: 'legal-security' }">Seguridad</b-link>
                <b-link :to="{ name: 'legal-refunds' }">Devoluciones</b-link>
                <b-link :to="{ name: 'legal-delivery' }">Entrega</b-link>
                <b-link :to="{ name: 'legal-contact' }">Contacto</b-link>
            </div>

            <!-- Datos del comercio -->
            <div class="business-info">
                <div>
                    {{ business.name }} · {{ business.address }} ·
                    {{ business.country }}
                </div>
                <div>
                    <a :href="`tel:${business.phone}`">{{ business.phone }}</a>
                    ·
                    <a :href="`mailto:${business.email}`">{{
                        business.email
                    }}</a>
                </div>
            </div>

            <!-- Footer -->
            <div class="page-footer">
                <feather-icon icon="LockIcon" size="14" />
                <span>Conexión segura</span>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { email, required } from "@validations";
import {
    BAlert,
    BButton,
    BCard,
    BCardText,
    BCardTitle,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BImg,
    BLink,
    BRow,
    BSpinner,
    VBTooltip,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import business from "@/business";
import LoginSessions from "./LoginSessions.vue";

export default {
    directives: {
        "b-tooltip": VBTooltip,
    },
    components: {
        BRow,
        BCol,
        BButton,
        BForm,
        BFormInput,
        BFormGroup,
        BCard,
        BCardTitle,
        BLink,
        BCardText,
        BSpinner,
        BAlert,
        ValidationProvider,
        ValidationObserver,
        ToastificationContent,
        BImg,
        BLink,
        LoginSessions,
    },
    data() {
        return {
            userEmail: "",
            required,
            email,
            isLoading: false,
            business,
            app: {
                banner: "",
                nombre: "",
                logo: "",
            },
            imgPayPal: require("@/assets/images/logo/paypal.png"),
            brands: {
                visa: require("@/assets/images/brands/visa.jpg"),
                mastercard: require("@/assets/images/brands/mastercard.jpg"),
                visaSecure: require("@/assets/images/brands/visa-secure.png"),
                mcIdCheck: require("@/assets/images/brands/mastercard-idcheck.png"),
            },
        };
    },
    created() {
        this.$http
            .get("/get-env")
            .then((response) => {
                this.app.banner = response.data.data.app_banner;
                this.app.name = response.data.data.app_name;
                this.app.logo = response.data.data.app_logo;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    mounted() {
        this.userEmail =
            this.$route.params.email != "undefined"
                ? this.$route.params.email
                : null;
    },
    methods: {
        sendMagicLink() {
            this.$refs.loginForm.validate().then((success) => {
                if (success) {
                    this.isLoading = true;

                    useJwt
                        .sendMagicLink(this.userEmail)
                        .then((response) => {
                            this.isLoading = false;
                            this.showToast(
                                response.data.message,
                                "success",
                                "MailIcon"
                            );
                            // Redirigir a página de confirmación
                            this.$router.push({
                                name: "magic-link-sent",
                                params: { email: this.userEmail },
                            });
                        })
                        .catch((error) => {
                            this.isLoading = false;
                            this.$swal({
                                title: "Error",
                                text:
                                    error.response?.data?.message ||
                                    error.message,
                                icon: "error",
                            });
                        });
                }
            });
        },
        showToast(message, variant, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message,
                    variant: variant,
                    icon: icon,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/pages/page-auth.scss";
@import "@/assets/scss/auth-minimal";

/* El logo lo dimensiona `_auth-minimal.scss` (96px, 70px en móvil). Acá había un
   override a 40px que lo dejaba en menos de la mitad, y encima desalineado con
   MagicLinkSent y VerifyMagicLink, que son las dos pantallas siguientes del
   mismo flujo y no lo pisan. */

.login-header .login-title {
    font-size: 1.625rem;
    font-weight: 700;
}

.payment-images .brand-img {
    height: 22px;
}
</style>
